import * as React from 'react';
import { ModalOverflow, ModalContent } from './ProductExcludedModalStyle';
import withCountryCode from '../RoutesHoc/RoutesHoc';
import Button from '../UI/Button';
import Row from '../UI/Row';

const ProductExcludedModal: React.ComponentType<{
  category: string;
  categoryPath: any;
  buildUrlWithCountry: (route?: string) => string;
}> = ({ category, categoryPath, buildUrlWithCountry }) => (
  <React.Fragment>
    <ModalContent data-cy="modal-product-excluded">
      <div>
        <Row justifyContent="center" margin="0 0 10px">
          Sorry, this item is not available in your region.
        </Row>
        <Row justifyContent="center" style={{ textAlign: 'center' }}>
          Continue discovering italist's luxury fashion offerings
        </Row>
        <Row justifyContent="center">
          or browse our&nbsp;
          <a style={{ textDecoration: 'underline' }} href={buildUrlWithCountry()}>
            homepage
          </a>
          .
        </Row>
        <Row justifyContent="center" margin="25px 0 0">
          <Button
            data-cy="button-product-excluded"
            backgroundColor={'#000000'}
            color="#FFFFFF"
            borderRadius="2px"
            width="290px"
            border="none"
            fontSize="15px"
            onClick={() =>
              (window.location.href = buildUrlWithCountry(`/${categoryPath.ancestors}/${categoryPath.category_id}`))
            }
            height="40px"
            type="submit"
          >
            SHOP {category.toUpperCase()}
          </Button>
        </Row>
      </div>
    </ModalContent>
    <ModalOverflow />
  </React.Fragment>
);

export default withCountryCode(ProductExcludedModal);
